import axios, {
  AxiosInstance,
  AxiosRequestHeaders,
  CancelTokenSource,
  InternalAxiosRequestConfig,
} from 'axios';

import { BrowserStorageService } from '@/services/BrowserStorage';

const BACK_END_API_ROOT_URL = import.meta.env.VITE_API_ROOT_URL;
const Axios: AxiosInstance = axios.create({
  baseURL: `${BACK_END_API_ROOT_URL}api`,
  headers: {
    'Content-Type': 'application/json; charset=utf-8',
    Accept: 'application/json',
  },
});

const requests: { [requestName: string]: CancelTokenSource | undefined } = {};

Axios.interceptors.request.use((config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  if (config.url && (config.method === 'get' || config.method === 'GET')) {
    if (requests[config.url]) {
      requests[config.url]?.cancel('AxiosService: Cancelling previous request!');
    }

    requests[config.url] = axios.CancelToken.source();
    config.cancelToken = requests[config.url]?.token;
  }

  const adminAccessToken = BrowserStorageService.portalAccessToken.get(true);
  const rooferAccessToken = BrowserStorageService.portalAccessToken.get();
  const portalAccessToken = adminAccessToken || rooferAccessToken;

  if (portalAccessToken && !config.headers?.Authorization) {
    if (!config.headers) {
      config.headers = {} as AxiosRequestHeaders;
    }
    config.headers.Authorization = `Bearer ${portalAccessToken}`;
  }

  return config;
});

export { Axios };
